import {configureStore} from '@reduxjs/toolkit'
import rootReducer from './reducer'
import {fetchLabels} from './reducer/labels.reducer'
import {fetchConfig} from './reducer/settings.reducer'
import {fetchLogo} from './reducer/brand.reducer'
import {hideModal} from './reducer/modal.reducer'
import {resetOrderDetails} from './reducer/order_details.reducer'
import httpClient from '../services'
import utils from '../utils'
import history from '../@f_routeshere/history'

/* LATERAL USE:
========================== */
const store = configureStore({
  reducer: rootReducer,
})

// Dispatch action on initial load
const initiateFetchLabels = (orderGUID: string) => {
  const languageCode = window.navigator.language.split('-')[0]
  store.dispatch(fetchLabels({orderGUID, languageCode}))
}

const initiateFetchConfig = (orderGUID: string) => {
  store.dispatch(fetchConfig(orderGUID))
}

const initiateFetchLogo = (orderGUID: string) => {
  store.dispatch(fetchLogo(orderGUID))
}

// Include all load action inside this function
// eslint-disable-next-line
const initiateFetchOnLoad = () => {
  const orderGUID = utils.getParamsFromURL('orderGUID')
  if (orderGUID) {
    initiateFetchLabels(orderGUID)
    initiateFetchConfig(orderGUID)
    initiateFetchLogo(orderGUID)
  } else {
    history.push('/500')
  }
}

const onLoad = () => {
  // Dont call on Demostyled page , Not Found, and Internal Server Error Page
  const isWhiteListedPage = utils.isWhiteListedPage()
  if (isWhiteListedPage) {
    httpClient.setBaseUrl().then(initiateFetchOnLoad)
  }
}

onLoad()

export const resetStore = () => {
  // Delay the reset store action to overwrite the action updates
  setTimeout(() => {
    store.dispatch(hideModal())
    store.dispatch(resetOrderDetails())
  }, 1000)
}

export default store

export type RootState = ReturnType<typeof store.getState>

export type Dispatch = typeof store.dispatch
